import modules_wiki from './wiki/index.js'
import modules_user from './user/index.js'
import modules_subsidies from './subsidies/index.js'
import modules_styler from './styler/index.js'
import modules_settings from './settings/index.js'
import modules_reports from './reports/index.js'
import modules_personal from './personal/index.js'
import modules_finances from './finances/index.js'
import modules_dictionary from './dictionary/index.js'
import modules_dictionaries from './dictionaries/index.js'
import modules_clients from './clients/index.js'
import modules_certificates from './certificates/index.js'
import modules_balanceSheet from './balanceSheet/index.js'
import modules_adminPaymentSystem from './adminPaymentSystem/index.js'
import _actions_set_title from './_actions/set_title.js'
import _actions_settings from './_actions/settings.js'
import _actions_logout from './_actions/logout.js'
import _actions_error from './_actions/error.js'
import _actions_create from './_actions/create.js'
import _getters_settings from './_getters/settings.js'
import _getters_permission from './_getters/permission.js'
import _getters_login from './_getters/login.js'
import state from './_state/index.js'

export default {
    namespaced: true,
    state,
    getters:{
        login: _getters_login,
        permission: _getters_permission,
        settings: _getters_settings,
    },
    actions:{
        create: _actions_create,
        error: _actions_error,
        logout: _actions_logout,
        settings: _actions_settings,
        set_title: _actions_set_title,
    },
    modules:{
        adminPaymentSystem: modules_adminPaymentSystem,
        balanceSheet: modules_balanceSheet,
        certificates: modules_certificates,
        clients: modules_clients,
        dictionaries: modules_dictionaries,
        dictionary: modules_dictionary,
        finances: modules_finances,
        personal: modules_personal,
        reports: modules_reports,
        settings: modules_settings,
        styler: modules_styler,
        subsidies: modules_subsidies,
        user: modules_user,
        wiki: modules_wiki,
    },
}